import { API_URL } from 'constants/envConstants';

export enum UNIFIED_MODEL_NAMES {
  BOMS = 'boms',
}
const API_URL_UNIFIED = `${API_URL}/unified`;

interface UnifiedUrls {
  BOMS: (query?: string) => string;
  TOGGLE_APPROVE: (modelName: UNIFIED_MODEL_NAMES) => string;
  TOGGLE_UNAPPROVE: (modelName: UNIFIED_MODEL_NAMES) => string;
  TOGGLE_ARCHIVE: (modelName: UNIFIED_MODEL_NAMES) => string;
  TOGGLE_UNARCHIVE: (modelName: UNIFIED_MODEL_NAMES) => string;
  TOGGLE_LOCK: (modelName: UNIFIED_MODEL_NAMES) => string;
  TOGGLE_UNLOCK: (modelName: UNIFIED_MODEL_NAMES) => string;
}

export const UNIFIED_URLS: UnifiedUrls = {
  BOMS: (query = '') =>
    `${API_URL_UNIFIED}/${UNIFIED_MODEL_NAMES.BOMS}/${query}`,
  TOGGLE_APPROVE: (modelName: UNIFIED_MODEL_NAMES) =>
    `${API_URL_UNIFIED}/${modelName}/approve/`,
  TOGGLE_UNAPPROVE: (modelName: UNIFIED_MODEL_NAMES) =>
    `${API_URL_UNIFIED}/${modelName}/unapprove/`,
  TOGGLE_ARCHIVE: (modelName: UNIFIED_MODEL_NAMES) =>
    `${API_URL_UNIFIED}/${modelName}/archive/`,
  TOGGLE_UNARCHIVE: (modelName: UNIFIED_MODEL_NAMES) =>
    `${API_URL_UNIFIED}/${modelName}/unarchive/`,
  TOGGLE_LOCK: (modelName: UNIFIED_MODEL_NAMES) =>
    `${API_URL_UNIFIED}/${modelName}/lock/`,
  TOGGLE_UNLOCK: (modelName: UNIFIED_MODEL_NAMES) =>
    `${API_URL_UNIFIED}/${modelName}/unlock/`,
};
